import { Outlet, useNavigate } from 'react-router-dom';

import logo from './uSwitch-Logo.avif'; 
import Navbar from '../Navbar/navbar';
import Button, { ButtonProps } from '@mui/material/Button';

const SharedLayout = (mypropin) => {  
    console.log('sharedpropIn', mypropin);
    return (
        <>     
        <img src={logo} alt="Logo" />  
            <Navbar  props={mypropin.props} />
            <Outlet />
        </>
    );
};
export default SharedLayout;

